import React, { Component } from 'react';

class Incrementor extends Component {
  updateValue(dir){
    this.props.update(dir);
  }
  render() {
    return (
      <div className="input-group incrementor">
        <span className="input-group-btn">
          <button className="btn btn-default" type="button"
            onClick={this.updateValue.bind(this, -1)}>
            <span className="glyphicon glyphicon-minus"></span>
          </button>
        </span>
        <input type="text" className="form-control"
          placeholder="Quantity"
          readOnly
          value={this.props.value} />
        <span className="input-group-btn">
          <button className="btn btn-default" type="button"
            onClick={this.updateValue.bind(this, 1)}>
            <span className="glyphicon glyphicon-plus"></span>
          </button>
        </span>
      </div>
    );
  }
}

export default Incrementor;



// WEBPACK FOOTER //
// ./src/pages/components/Incrementor.js